import { createContext, ReactNode, useContext } from "react";

import { useFilterRatePerPax } from "./filter-rate-per-pax.hook";

const FilterRatePerPaxContext = createContext(
  {} as ReturnType<typeof useFilterRatePerPax>
);
export function useFilterRatePerPaxContext() {
  return useContext(FilterRatePerPaxContext);
}

interface FilterRatePerPaxProviderProps {
  children: ReactNode;
}
export function FilterRatePerPaxProvider({
  children,
}: FilterRatePerPaxProviderProps) {
  return (
    <FilterRatePerPaxContext.Provider value={useFilterRatePerPax()}>
      {children}
    </FilterRatePerPaxContext.Provider>
  );
}